import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';
import { LiveStream } from '../modal';

export default function reducer(state: LiveStream = new LiveStream(), action: AnyAction) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.LIVE_STREAMING_LIST_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.LIVE_STREAMING_LIST_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.LIVE_STREAMING_LIST_ERROR:
      return {
        ...state,
        loadingInProgress: false,
        loadingError: payload,
      };
    default:
      return state;
  }
}
